import React, {useCallback, useEffect, useRef, useState} from "react";
import Section1 from "../components/Section1";
import LayoutsList from "../components/LayoutsList";
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faXmark } from "@fortawesome/free-solid-svg-icons";
import { apiUrl, assetsUrl } from "../config/Config";
import axios from "axios";
import starimg from '../assets/images/main/stars-img.png';
import leftborder from '../assets/images/leftborder.png';
import rightborder from '../assets/images/rightborder.png';

const PAGE_SIZE = 12;

const FindLayouts = () => {
    
    const navigate = useNavigate();
    const location = useLocation();
    const {search} = location.state || {};
    const [searchtext, setsearchtext] = useState(search);
    const [layoutdata, setlayoutdata] = useState([]);
    const [currentPage, setcurrentPage] = useState(1);
    const [hasMoreLayouts, sethasMoreLayouts] = useState(true);
    const [layoutsLoading, setlayoutsLoading] = useState(false);
    const loaderRef = useRef(null);
    const requestIdRef = useRef(0);

    const fetchlayouts = useCallback(async(text, page = 1, append = false) => {
        const requestId = requestIdRef.current + 1;
        requestIdRef.current = requestId;
        setlayoutsLoading(true);
        var data = {
            text: text || "",
            page: page,
            limit: PAGE_SIZE
        }
      await axios
            .post(apiUrl + "findlayouts", data)
            .then((res) => {
              if (requestId !== requestIdRef.current) {
                return;
              }
              if (res.data.status == "success") {
                var prevdata = res?.data?.data || [];
                if(prevdata?.length > 0) {
                  setlayoutdata((olddata) => append ? [...olddata, ...prevdata] : prevdata);
                } else {
                  if (!append) {
                    setlayoutdata([]);
                  }
                }
                sethasMoreLayouts(
                  typeof res?.data?.has_more === "boolean"
                    ? res.data.has_more
                    : prevdata?.length === PAGE_SIZE
                );
              } else {
                sethasMoreLayouts(false);
              }
            })
            .catch(() => {
              if (requestId === requestIdRef.current) {
                sethasMoreLayouts(false);
              }
            })
            .finally(() => {
              if (requestId === requestIdRef.current) {
                setlayoutsLoading(false);
              }
            });
    }, [])
    const handlesearchclick = () => {

    }

    const clearsearchtext = () => {
        setsearchtext("");
    }
    useEffect(() => {
        // setsearchtext(search);
        if(search) {
          window.scrollTo({
            top: 550,
            behavior: 'smooth', // optional smooth scroll
          });
        }
       
    }, [search])

    useEffect(() => {
        setcurrentPage(1);
        sethasMoreLayouts(true);
        fetchlayouts(searchtext, 1, false);
    }, [fetchlayouts, searchtext])

    useEffect(() => {
      if (currentPage === 1) {
        return;
      }
      fetchlayouts(searchtext, currentPage, true);
    }, [currentPage, fetchlayouts, searchtext])

    useEffect(() => {
      const loader = loaderRef.current;
      if (!loader || !hasMoreLayouts || layoutsLoading) {
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          if (entries[0]?.isIntersecting) {
            setcurrentPage((page) => page + 1);
          }
        },
        { rootMargin: "200px" }
      );

      observer.observe(loader);

      return () => {
        observer.disconnect();
      };
    }, [hasMoreLayouts, layoutsLoading, layoutdata?.length])

    useEffect(() => {
      if (location.state?.search) {
        // Clear state immediately after first render
        navigate(location.pathname, { replace: true });
      }
    }, [location, navigate]);
    return (
      <div className="homepage-layout">
        <section>
          <div className="section1main findlayout_section1main">
            <div className="container">
              <p className="section1title">
                Find the perfect <br />
                PowerPoint presentation layout
              </p>
              <div className="section1searchdiv">
                {searchtext?.length > 0 ? (
                  <div className="searchclearicon" onClick={() => {clearsearchtext()}}>
                    <FontAwesomeIcon
                      icon={faXmark}
                      className="section1icon1"
                    />
                  </div>
                ) : null}
                {/* <div
                  className="searchicondiv"
                  onClick={() => {
                    handlesearchclick();
                  }}
                >
                  <FontAwesomeIcon
                    icon={faMagnifyingGlass}
                    className="section1icon"
                  />
                </div> */}
                <div className="searchicondivnew"  onClick={() => {
                  window.scrollTo({
                    top: 500,
                    behavior: 'smooth', // optional smooth scroll
                  });
                }}>
                  <img src={starimg} className="start-img" />
                  <p>Search</p>
                </div>
                <input
                  value={searchtext}
                  onChange={(t) => {
                    setsearchtext(t.target.value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      // handlesearchclick();
                      window.scrollTo({
                        top: 500,
                        behavior: 'smooth', // optional smooth scroll
                      });
                    }
                  }}
                  type="text"
                  className="searchinputdiv"
                />
              </div>
              <p className="section1desc">
                Bring your next layout to life with customizable PowerPoint
                design layouts. Whether you're wowing with stats via charts and
                graphs or putting your latest and greatest ideas on display,
                you'll find a PowerPoint presentation layout to make your ideas
                pop.
              </p>
              
            </div>
          </div>
        </section>
        <section>
          <div className="section3bg">
            {/* <div className="howitworkstitlediv">
              <div className="thinborder" style={{width: '14%'}}></div>
              <div className="thindotdiv">
                <div className="thindot"></div>
              </div>
              <div className="bordertitlediv" style={{width: '70%'}}>
                <p>Start with our best PowerPoint layouts</p>
              </div>
              <div className="thindotdiv">
                <div className="thindot thindot1"></div>
              </div>
              <div className="thinborder" style={{width: '14%'}}></div>
              
            </div> */}
            <div className="container">
              <div className="howitworkstitlediv">
                <div className="newthinleftborder">
                  <img src={leftborder} className="newleftborder" />
                </div>
                <div className="bordertitlediv findlayouttitle">
                  <p>Start with our best PowerPoint layouts</p>
                </div>
                <div className="newthinrightborder">
                  <img src={rightborder} className="newleftborder" />
                </div>
              </div>
            </div>
            <div className="container">
              {
                layoutdata?.length > 0 ?
                <>
                  {/* <p className="section3-title">
                Start with our best PowerPoint layouts
              </p> */}
              <div className="row pplayoutsrow">
                    {layoutdata?.map((item, index) => {
                      return (
                        <div
                          className="col-12 col-sm-6 col-md-4 mb-4"
                          onClick={() => {
                            navigate(
                              "/customize-layout" +
                                "/" +
                                item?.id +
                                "/" +
                                item?.slug
                            );
                          }}
                          key={index}
                        >
                          {/* <img
                            src={assetsUrl + "images/" + item?.image}
                            className="layout-tumb"
                          /> */}
                          <img
                            src={assetsUrl + item?.image}
                            className="layout-tumb"
                          />
                        </div>
                      );
                    })}
                  </div>
                  {hasMoreLayouts ? (
                    <div ref={loaderRef} className="layouts-loader">
                      {layoutsLoading ? <span></span> : null}
                    </div>
                  ) : null}
                </> :
                  !layoutsLoading ? <h5 style={{marginTop: -25, textAlign: 'center', color: '#fff'}}>No Layouts found</h5> : null
              }
              {layoutsLoading && layoutdata?.length === 0 ? (
                <div className="layouts-loader initial-layouts-loader">
                  <span></span>
                </div>
              ) : null}
              
            </div>
          </div>
        </section>
      </div>
    );
}

export default FindLayouts;
